exports.install = function(Vue, options) {

  Vue.prototype.changeIdToName = function(id){
    console.log(id)
      if(!id)
          return "";
      id+="";
      let arr = id.split("-");
      let footstr = '';
      id = arr[0];
      if(arr.length>1){
        footstr = arr[1]
      }
      switch(id){
          case "11":
              return "比例环节"+footstr
          case "12":
              return "积分环节"+footstr
          case "13":
              return "PD环节"+footstr
          case "14":
              return "PI环节"+footstr
          case "15":
              return "PID环节"+footstr
          case "16":
            return "惯性环节" +footstr
          case "17":
            return "信号发生器" +footstr
          case "18":
            return "示波器" +footstr
          case "19":
            return "微分环节" +footstr  
          case "21":
            return "信号相加相减环节" +footstr  
          default:
              return ""+footstr
      }
  }

}


// WEBPACK FOOTER //
// ./src/assets/js/globalFunctions.js